import { Context } from '@z-components/utils/oauth';

export const makeContextHeader = (
  context?: Context
): { 'x-social-context': string } | Record<string, unknown> =>
  context === undefined ? {} : { 'x-social-context': context };

export const makeSourceHeader = (
  source?: string
): { 'client-source': string } | Record<string, unknown> =>
  source === undefined ? {} : { 'client-source': source };
